/*
  react-confirm interacts with the DOM in such a way that the pack must be deferred
  Example (.html.slim): `= javascript_pack_tag "application", defer: true`
*/

import { createConfirmation } from "react-confirm";
import Confirm from "./confirm_dialog";

const confirm = createConfirmation(Confirm);

export default (message, options = {}) => confirm({ message, options });
